import fileSaver from 'file-saver';
import t from './ColorLibrary.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as ColorLibraryService from '../../../../services/color-library.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const fetchColorLibrary = (data) => async (dispatch) => {
  try {
    const fetchres = await ColorLibraryService.getColorLibrary(data);
    if (fetchres && fetchres.code === 200 && fetchres.data) {
      const colourWayData = data.isToLoadPaginationWise ? fetchres?.data?.arrColourWay : fetchres?.data;
      const fetchColordata = colourWayData?.map((item) => ({
        ...item,
        isDisable: false,
      }));
      if (data.from === 'search') {
        await dispatch({
          type: t.FETCH_OPTIONS,
          payload: fetchColordata,
        });
      } else if (data?.isToLoadPaginationWise) {
        await dispatch({
          type: t.FETCH_COLORS,
          payload: {
            ...data,
            data: fetchColordata,
            totalDocuments: fetchres.data.totalDocuments,
            searchText: data.searchText,
            isScrolled: data.isScrolled,
          },
        });
        if (fetchres.data.listOptions && Array.isArray(fetchres.data.listOptions)) {
          const listOptionsData = fetchres.data.listOptions.map((item) => ({
            ...item,
            isDisable: false,
          }));
          await dispatch({ type: t.FETCH_COLORS_LIST, payload: listOptionsData });
        }
      } else {
        await dispatch({
          type: t.FETCH_COLORS,
          payload: fetchColordata,
        });
      }
      return fetchColordata;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const emptyReducer = () => async (dispatch) => {
  try {
    return await dispatch({ type: t.EMPTY_REDUCER });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({ type: t.CLEAR_DOCUMENTS });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchColorGroupLibrary = (data) => async (dispatch) => {
  try {
    const fetchCgres = await ColorLibraryService.getColorGroupLibrary(data);
    if (fetchCgres && fetchCgres.code === 200 && fetchCgres.data) {
      const fetchdata = fetchCgres.data.map((item) => ({
        ...item,
        isDisable: false,
      }));
      return await dispatch({ type: t.FETCH_COLORS_GROUP, payload: fetchdata });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchColorGroupEditLibrary = (data) => async (dispatch) => {
  try {
    const fetchCgeres = await ColorLibraryService.addColorGroupEditLibrary(data);
    if (fetchCgeres && fetchCgeres.code === 200 && fetchCgeres.data) {
      const fetchColorGroupdata = fetchCgeres.data;
      return await dispatch({
        type: t.FETCH_COLORS_GROUP_EDIT,
        payload: fetchColorGroupdata,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getColourSupportingDocuments = (data) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.getColourSupportingDocs(data);
    if (res?.code === 200) {
      return await dispatch({
        type: t.FETCH_COLORS_SUPPORTING_DOCUMENTS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getIndividualSupportingDocuments = (data) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.getOneColourSupportingDoc(data);
    if (res?.code === 200) {
      return await dispatch({
        type: t.EDIT_SUPPORTING_DOCUMENTS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const modifiedColorLibrary = (data) => async (dispatch) => {
  try {
    return await dispatch({ type: t.DESABLE_COLOR, payload: data });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addColorLibrary = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.addColorLibrary(data);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      const value = res.data;
      await dispatch({
        type: t.ADD_COLORS,
        payload: { ...value, isDisable: false },
      });

      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addColorLibraryGroup = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.addColorGroupLibrary(data);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return await dispatch({
        type: t.ADD_COLORS_GROUP,
        payload: res.data.insertedId,
      });
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addColourSupportingDocs = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.colourSupportingDocs(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`COLOUR_SUPPORTING_DOCUMENTS.${res.message}`);
      toasterMsg(msg, 'success');
      return await dispatch({
        type: t.FETCH_COLORS_SUPPORTING_DOCUMENTS,
        payload: [res.data.doc],
      });
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');

    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editColorLibrary = (data, id, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.editColorLibrary(data, id);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      const value = res.data;
      return await dispatch({
        type: t.EDIT_COLORS,
        payload: { ...value, isDisable: false },
      });
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(transactionMsg(err.toString()), 'danger');
  }
};

export const editColorSupportingDocs = (data, transactionMsg) => async () => {
  try {
    const res = await ColorLibraryService.editColorSupportingDocuments(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`COLOUR_SUPPORTING_DOCUMENTS.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(transactionMsg(err.toString()), 'danger');
  }
};

export const editColorGroupLibrary = (data, id, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.editColorGroupLibrary(data, id);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      const value = res.data;
      return await dispatch({
        type: t.EDIT_COLORS_GROUP,
        payload: { ...value, isDisable: false },
      });
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteColorLibrary = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.deleteColorLibrary(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      const value = res.data;
      return await dispatch({
        type: t.DELETE_COLORS,
        payload: { ...value, isDisable: false },
      });
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteMultiColorLibrary = (data, transactionMsg) => async () => {
  try {
    const respo = await ColorLibraryService.deleteMultipleColorLibrary(data);
    if (respo && respo.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${respo.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(respo.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteColorGroup = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.deleteColorGroup(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      const value = res.data;
      return await dispatch({
        type: t.DELETE_COLORS_GROUPS,
        payload: { ...value, isDisable: false },
      });
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteColorSupportingDocsUnsaved = (data, transactionMsg) => async () => {
  try {
    const res = await ColorLibraryService.deleteUnsavedColourSupportingDocuments(data);
    if (res?.code === 200) {
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteColorSupportingDocs = (data, transactionMsg) => async () => {
  try {
    const res = await ColorLibraryService.deleteColourSupportingDocuments(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`COLOUR_SUPPORTING_DOCUMENTS.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const previewsColorMergedPdf = (data, trans) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.getColorMergedPdf(data);
    if (res?.code === 200 && res.data !== '') {
      if (res.data === '') {
        toasterMsg(trans('COLOUR_SUPPORTING_DOCUMENTS.SUPPORTING_DOCUMENT.NO_PDF_MERGE'), 'danger');
      } else {
        await dispatch({
          type: t.MERGED_PDF_PREVIEW,
          payload: res.data,
        });
      }
      return true;
    }
    toasterMsg(trans(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteMergedDocs = (data, trans) => async (dispatch) => {
  try {
    const res = await ColorLibraryService.deleteMergedDocuments(data);
    if (res?.code === 200) {
      console.log(res.data, '===========================================================');
      await dispatch({
        type: t.MERGED_PDF_DELETE,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(trans(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const removeColourSupportingDocument = (data) => async (dispatch) => {
  try {
    return await dispatch({
      type: t.REMOVE_COLOUR_SUPPORTING_DOCUMENTS,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchColorListLibrary = (data) => async (dispatch) => {
  try {
    const fetchres = await ColorLibraryService.getColorListLibrary(data);
    if (fetchres && fetchres.code === 200 && fetchres.data) {
      const fetchColorListdata = fetchres.data.map((item) => ({
        ...item,
        isDisable: false,
      }));
      if (data.from === 'search') {
        await dispatch({
          type: t.FETCH_OPTIONS,
          payload: fetchColorListdata,
        });
      } else {
        await dispatch({
          type: t.FETCH_COLORS_LIST,
          payload: fetchColorListdata,
        });
      }
      return fetchColorListdata;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchColorGroupListLibrary = (data) => async (dispatch) => {
  try {
    const fetchCgres = await ColorLibraryService.getColorGroupListLibrary(data);
    if (fetchCgres && fetchCgres.code === 200 && fetchCgres.data) {
      const fetchdata = fetchCgres.data.map((item) => ({
        ...item,
        isDisable: false,
      }));
      return await dispatch({ type: t.FETCH_COLORS_GROUP_LIST, payload: fetchdata });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadColourLibrary = (data, trans) => async () => {
  try {
    const res = await ColorLibraryService.exportExcelService(data);
    if (res) {
      if (data?.type) {
        fileSaver.saveAs(res, 'Sample Colourway');
      } else {
        fileSaver.saveAs(res, 'Colourway');
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(trans(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const importColLib = (params, trans) => async () => {
  try {
    const response = await ColorLibraryService.uploadFile(params);
    if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(trans(`BOM_LIBRARY_VIEW.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(trans(`BOM_LIBRARY_VIEW.${response.message}`), 'danger');
    } else {
      toasterMsg(trans(response.data.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchColourGroupbyPgination = (data) => async (dispatch) => {
  try {
    const fetchCgres = await ColorLibraryService.fetchColourGroupbyPgination(data);
    if (fetchCgres && fetchCgres.code === 200 && fetchCgres.data) {
      const fetchdata = fetchCgres?.data?.arrResponse?.map((item) => ({
        ...item,
        isDisable: false,
      }));
      dispatch({
        type: t.FETCH_COLOUR_GROUP_PAGINATION,
        payload: {
          data: fetchdata,
          totalColourGroupCount: fetchCgres.data.totalCounts,
          searchText: data.searchText,
          isScrolled: data.isScrolled,
        },
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
